function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import { DEFAULT_TPL_FIELDS, METADATA_FILE_FORMAT, METADATA_IMAGE_FORMAT, ROLES_LIST, PATTERNS_VALIDATION } from '@/js/constants';
import BiReportService from '@/apps/data-platform/services/visualization/bi_report_service';
import { businessGlossaryMixin } from '@/mixins/business_glossary';
import tasks from '@/js/tasks';
export default {
  name: 'ReportTabBusinessTerm',
  mixins: [businessGlossaryMixin],
  props: {
    item: {
      type: Object,
      default: function _default() {}
    },
    showButton: {
      type: Boolean,
      default: true
    },
    readonly: {
      type: Boolean,
      default: false
    },
    isChangeRequest: {
      type: String,
      default: ''
    },
    valid: {
      type: Object,
      default: function _default() {
        return {
          kdomain: null,
          ksubdomain: null,
          kbusiness_term: null
        };
      }
    }
  },
  computed: _objectSpread({
    headers: function headers() {
      return [{
        value: 'index',
        text: 'N°'
      }, {
        value: 'domain_description',
        text: this.traductor('my_tasks.modals.domain')
      }, {
        value: 'subdomain_description',
        text: this.traductor('my_tasks.modals.subdomain')
      }, {
        value: 'term_description',
        text: this.traductor('my_tasks.tablas_tasks.bterm')
      }, {
        value: 'term_definition',
        text: this.traductor('my_tasks.tablas_tasks.definition')
      }, {
        value: 'actions',
        text: ''
      }];
    },
    filterDomain: function filterDomain() {
      return this.selectDomain;
    },
    filterSubDomain: function filterSubDomain() {
      var _this = this;
      var selectbSubdomain = this.selectSubdomain.filter(function (x) {
        return x.domain.includes(_this.kdomain);
      });
      return selectbSubdomain;
    },
    filterTermsAssigned: function filterTermsAssigned() {
      return this.item.business_terms.filter(function (x) {
        return !x.deleted;
      });
    },
    showButtonAttachment: function showButtonAttachment() {
      var userInfo = window.userInfo;
      var dataOperator = this.item.data_operator;
      var userRoles = userInfo.userRoles || [];
      return userRoles.includes(ROLES_LIST.ORG_DATA_STEWARD) || dataOperator === userInfo.email;
    }
  }, mapState('data-platform', ['selectDomain', 'selectSubdomain', 'selectBusinessTerm'])),
  data: function data() {
    return {
      DEFAULT_TPL_FIELDS: DEFAULT_TPL_FIELDS,
      METADATA_FILE_FORMAT: METADATA_FILE_FORMAT,
      METADATA_IMAGE_FORMAT: METADATA_IMAGE_FORMAT,
      dismissSecs: 8,
      dangerMessage: '',
      environ_initial: '',
      inputUploadFile: null,
      domain_table: '',
      files: [],
      currentFile: {},
      PATTERNS_VALIDATION: PATTERNS_VALIDATION,
      kdomain: null,
      ksubdomain: null,
      kbusiness_term: null,
      bt_add: {
        kdomain: null,
        domain_description: '',
        organization: '',
        ksubdomain: null,
        subdomain_description: '',
        kbusiness_term: null,
        term_description: '',
        term_definition: '',
        in_report: true
      },
      bterms: []
    };
  },
  created: function created() {
    this.domain_table = window.userInfo.domain;
    this.environ_initial = this.item['environment'];
    this.files = this.item.files || [];
    if (this.item.business_terms != null) this.bterms = this.item.business_terms;
  },
  mounted: function mounted() {
    this.$store.dispatch('data-platform/getSelectBusinessTerm');
  },
  methods: {
    onListTerminosNegocio: function onListTerminosNegocio(listTerms) {
      var business_terms_keys = [];
      this.item.business_terms.forEach(function (element) {
        business_terms_keys.push(element.kbusiness_term);
      });
      this.$emit('onListTerminosNegocio', business_terms_keys);
    },
    traductor: function traductor(key) {
      return this.$i18n.t(key);
    },
    onSubmit: function onSubmit() {
      this.item.business_terms = this.bterms;
      var business_terms_keys = [];
      this.item.business_terms.forEach(function (element) {
        business_terms_keys.push(element.kbusiness_term);
      });
      this.item.business_terms_keys = business_terms_keys;
      var report = {
        domain: window.userInfo.domain,
        report: this.item
      };
      BiReportService.reportAddUpdate(report).then(function (res) {
        if (res.success && res.code === 200) {
          if (res.success) {
            tasks.toast.success('Dataset fields updated !');
            //this.$toast.success('Dataset fields updated !')
            //this.onCancel()
            //this.$emit('onSave', report.report)
          } else {
            tasks.toast.error(res.message);
            //this.$toast.warning(res.message)
            //this.onCancel()
          }
        }
      });
    },
    getDomainUser: function getDomainUser() {
      return window.userInfo.domain;
    },
    onCancel: function onCancel() {
      this.$emit('onCancel', null);
    },
    isTermSelected: function isTermSelected(value) {
      return this.bterms ? this.bterms.filter(function (x) {
        return x.kbusiness_term == value;
      }).length > 0 : false;
    },
    onChangeDomain: function onChangeDomain() {
      var _this2 = this;
      var domain = this.selectDomain.find(function (x) {
        return x.kdomain == _this2.kdomain;
      });
      this.ksubdomain = null;
      this.kbusiness_term = null;
      this.bt_add = {
        kdomain: domain.kdomain,
        domain_description: domain.text,
        organization: domain.organization,
        ksubdomain: null,
        subdomain_description: '',
        kbusiness_term: null,
        term_description: '',
        term_definition: '',
        in_report: true
      };
    },
    onChangeSubdomain: function onChangeSubdomain() {
      var _this3 = this;
      var subdomain = this.selectSubdomain.find(function (x) {
        return x.value == _this3.ksubdomain;
      });
      console.log(subdomain);
      this.kbusiness_term = null;
      this.bt_add.ksubdomain = subdomain.value;
      this.bt_add.subdomain_description = subdomain.text, this.bt_add.kbusiness_term = null, this.bt_add.term_description = '', this.bt_add.term_definition = '';
    },
    onAddBusinessTerm: function onAddBusinessTerm() {
      console.log(this.bt_add);
      if (this.bt_add.kbusiness_term) {
        if (this.isTermSelected(this.bt_add.kbusiness_term)) {
          tasks.toast.error('The term is selected already!');
          //this.$toast.info('The term is selected already!')
          return;
        }
        this.bterms.push(this.bt_add);
        this.onLimpiarFiltros();
      } else {
        tasks.toast.error('No ha seleccionado nigun business term');
        //this.$toast.info('No ha seleccionado nigun business term')
      }
    },
    onRemoveBT: function onRemoveBT(object) {
      console.log('delete');
      var index = this.item.business_terms.indexOf(object);
      this.item.business_terms.splice(index, 1);
      console.log(this.item.business_terms);
    }
  }
};